import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/Team/team.html'
})

export class TeamComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public team: any[] = [];
    public country: any[] = [];
    public addTeamData: any = { addTeamCountry: "" };
    public editTeamData: any = { editTeamCountry: "" };
    public isAdd: boolean = true;
    active = true;
    public showLoader = false;
    public existsTeamName: boolean = false;
    public isFormSubmitted: boolean = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {
        this.getCountry();
        this.getTeam();
    }

    ExportItems() {
        ExportToExcel(this.team, "Team",
            ["TeamName", "CountryName"],
            ["Team Name", "Country Name"]);
    }

    ngAfterViewInit() {

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    public AddTeamFormLoad() {
        $('#btnAddTeamForm').trigger('click');
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }
    public getCountry() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["Country"] }).subscribe(
            data => {
                this.country = data["Parameter"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getTeam() {
        this.showLoader = true;
        this._httpService.ajaxPost('Team/GetTeam', { "TeamId": 0, "Country": 0 }).subscribe(
            data => {
                this.team = data["Team"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public CancelAddTeam() {
        this.existsTeamName = false;
        this.addTeamData = { addTeamCountry: "" };
        this.newForm();
        $('#addTeam').modal('hide');
        this.isAdd = true;
    }

    public CancelEditTeam() {
        this.existsTeamName = false;
        this.editTeamData = {};
        this.newForm();
        $('#editTeam').modal('hide');
        this.isAdd = true;
    }

    public AddTeam(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsTeamName = false;
            this.team.forEach(element => {
                if (element.TeamName.trim().toLowerCase() == this.addTeamData.addTeamName.trim().toLowerCase()) {
                    this.existsTeamName = true;
                }
            });

            if (!this.existsTeamName) {
                let objItem: any = {};
                objItem.TeamId = 0;
                objItem.TeamName = this.addTeamData.addTeamName;
                objItem.Country = this.addTeamData.addTeamCountry;
                this.addEditTeam(objItem);
                $('#addTeam').modal('hide');
                this.addTeamData = {};
                this.newForm();
                this.isAdd = true;
            }
        }
    }

    public EditTeam(item: any) {
        $('#btnEditTeamForm').trigger('click');
        this.isAdd = false;
        this.EditTeamChange(item.Team_Id);
    }

    public EditTeamChange(itemId) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.team.filter((team) => team.Team_Id == itemId)[0]));
        this.editTeamData.editTeamId = objItem.Team_Id;
        this.editTeamData.editTeamName = objItem.TeamName;
        this.editTeamData.editTeamCountry = objItem.Country;
    }

    public UpdateTeam(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsTeamName = false;
            this.team.forEach(element => {
                if (element.Team_Id != this.editTeamData.editTeamId && element.TeamName.trim().toLowerCase() == this.editTeamData.editTeamName.trim().toLowerCase()) {
                    this.existsTeamName = true;
                }
            })

            if (!this.existsTeamName) {
                let objItem: any = {};
                objItem.TeamId = this.editTeamData.editTeamId;
                objItem.TeamName = this.editTeamData.editTeamName;
                objItem.Country = this.editTeamData.editTeamCountry;
                this.addEditTeam(objItem);
                $('#editTeam').modal('hide');
                this.editTeamData = {};
                this.newForm();
                this.isAdd = true;
            }
        }
    }

    addEditTeam(objItem) {
        objItem.Created_By = this.userDetail.SiteUserId;
        objItem.Modified_By = this.userDetail.SiteUserId;
        this.showLoader = true;
        this._httpService.ajaxPost('Team/AddUpdateTeam', objItem).subscribe(
            data => {
                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.getTeam();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Team/team.component.ts
 **/